import React, { useEffect, useState } from 'react'
import LayoutHeader from '../../../adminnavigation/layoutHeader'
import { App, Button, Card, Col, Form, Input, InputNumber, Row, Select, Space, Table, Upload } from 'antd';
import { DELETE, GET, POST } from '../../../utils/apicalls';
import { API } from '../../../config/api';
import { useNavigate } from 'react-router-dom';

// import AWS from 'aws-sdk';
// import { KEYS } from '../../../config/keys';

function CourseModule() {
    const [isLoading, setIsLoading] = useState(false);
    const [form] = Form.useForm();
    const [form1] = Form.useForm();
    const { notification } = App.useApp(); // Use App context hook to access notification
    const navigate = useNavigate();
    const [allModuleData, setallModuleData] = useState<any>([]);
    const [allCourseData, setallCourseData] = useState<any>([]);
    const [CourseFilterData, setCourseFilterData] = useState<any>([]);



    const submitHandler = async (values: any) => {
        try {
            // Extracting strings from the arrays of objects
            let course_module_description = values.course_module_description.map((item: any) => item.description);

            let obj = {
                course_module_Title: values.course_module_Title,
                course_module_subTitle: values.course_module_subTitle,
                Course_id: Number(values.Course_id),
                course_module_image: values.course_module_image,
                course_module_description: course_module_description, // This is now an array of strings

            };

            setIsLoading(true);
            const postRequest = await POST(API.CREATE_COURSE_MODULE, obj);

            if (postRequest) {
                notification.success({ message: "Course created successfully!" });
                form.resetFields();
                feacthallCourseModule()
            } else {
                notification.error({ message: "Something went wrong" });
            }
        } catch (error) {
            console.error(error);
            notification.error({
                message: "Something went wrong! Please try again later",
            });
        } finally {
            setIsLoading(false);
        }
    };

    const feacthallCourse = async () => {
        try {
            setIsLoading(true);
            const response: any = await GET(API.GET_ALL_COURSES, {});
            setallCourseData(response?.data);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        feacthallCourse();
    }, []);
    const feacthallCourseModule = async () => {
        try {
            setIsLoading(true);
            const response: any = await GET(API.GET_ALL_COURSE_MODULES, {});
            setallModuleData(response?.data);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        feacthallCourseModule();
    }, []);

    const handleDelete = async (id: any) => {
        try {
            setIsLoading(true);
            const delete_customer_url = `${API.DELETE_COURSE_MODULE}${id}`;
            const data: any = await DELETE(delete_customer_url);

            if (data.status) {
                notification.success({ message: " deleted successfully!" });
                feacthallCourseModule();
            } else {
                notification.error({
                    message: "Something went wrong! Please try again later.",
                });
            }
        } catch (error) {
            console.log(error);
            notification.error({
                message: "Something went wrong! Please try again later.",
            });
        } finally {
            setIsLoading(false);
        }
    };

    const confirmDelete = (id: any) => {
        const confirm = window.confirm(
            "Are you sure you want to delete this review?"
        );
        if (confirm) {
            handleDelete(id);
        }
    };

    const columns = [
        {
            title: "Index",
            dataIndex: "index",
            render: (_: any, __: any, index: number) => index + 1,
        },
        { title: "course_module_Title", dataIndex: "course_module_Title" },
        { title: "course_module_subTitle", dataIndex: "course_module_subTitle" },
        {
            title: "Course",
            dataIndex: "Course_id",
            key: "category",
            render: (Course_id: number) => {
                const category = allCourseData.find((cat: any) => cat.id === Course_id);
                return category ? category.course_title : 'Unknown';
            }
        },

        // {
        //     title: "course_module_image", dataIndex: "course_module_image", render: (url: string) => (
        //         <img src={url} alt="Banner" style={{ width: 100, height: 100 }} />
        //     ),
        // },

        {
            title: "Course Module Description",
            dataIndex: "course_module_description",
            key: "course_module_description",
            render: (descriptions: string[]) => (
                <ul>
                    {descriptions?.map((desc, idx) => (
                        <li key={idx}>{desc}</li>
                    ))}
                </ul>
            )
        },

        {
            title: "Actions",
            key: "actions",
            render: (_: any, record: any) => (
                <Space size="middle">
                    <Button type="link" onClick={() => confirmDelete(record.id)}>Delete</Button>
                    <Button
                        type="link"
                        onClick={() =>
                            navigate(
                                `/Admin/adminCourseModule/updateCourseModule/${record.id}`
                            )
                        }
                    >
                        Edit
                    </Button>
                </Space>
            ),
        },
    ];

    const filterCourseData = async (values: any) => {
        try {
            setIsLoading(true);
            const api = API.FILTER_COURSE_MODULE;
            const response: any = await POST(api, values);

            if (response?.status && response.data.length > 0) {
                setCourseFilterData(response.data);
            } else {
                setCourseFilterData([]);
                notification.info({
                    message: "No data found for the selected course.",
                });
            }
        } catch (error) {
            console.log(error);
            notification.error({ message: "An error occurred while filtering." });
        } finally {
            setIsLoading(false);
        }
    };



    return (
        <div>
            <LayoutHeader />
            <h1 className="text-2xl font-bold mb-4 text-center" style={{ textAlign: "center" }}>Course Module Management</h1>


            <Card className="p-4 shadow-md rounded-md">
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={submitHandler}
                    className="flex flex-wrap gap-4"
                >
                    <Row gutter={16}>
                        {/* Course Title */}
                        <Col span={8}>
                            <Form.Item
                                label="Course Module Title"
                                name="course_module_Title"
                                rules={[{ required: true, message: 'Please input the course  Module title!' }]}
                            >
                                <Input placeholder="Enter course Module title" />
                            </Form.Item>
                        </Col>

                        {/* Course Price */}
                        <Col span={8}>
                            <Form.Item
                                label="Course Module  SubTitle"
                                name="course_module_subTitle"
                                rules={[{ required: true, message: 'Please input the course Module SubTitle!' }]}
                            >
                                <Input
                                    placeholder="Enter course Module SubTitle"
                                    min={0}
                                    style={{ width: '100%' }}
                                />
                            </Form.Item>
                        </Col>


                        <Col span={8}>
                            <Form.Item
                                label="Course"
                                name="Course_id"
                                rules={[{ required: true, message: 'Please select a Course!' }]}
                            >
                                <Select placeholder="Select a Course">
                                    {allCourseData.map((Course: { id: number; course_title: string }) => (
                                        <Select.Option key={Course.id} value={Course.id}>
                                            {Course.course_title}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16}>

                        {/* <Col span={8}>
                            <Form.Item
                                label="Course Module Image URL"
                                name="course_module_image"
                            // rules={[{ required: true, message: 'Please input the  image URL!' }]}
                            >
                                <Upload {...uploadProps.course_module_image}>
                                    <Button className="w-full">Upload Course Image</Button>
                                </Upload>
                                {renderFilePreview(fileUrl.course_module_image, "Course")}
                            </Form.Item>
                        </Col> */}
                        {/* Target Audience (Array) */}
                        <Col span={8}>
                            <Form.Item
                                label="Course Module Description"
                                name="course_module_description"
                                rules={[{ required: true, message: 'Please input at least one description!' }]}
                            >
                                <Form.List
                                    name="course_module_description"
                                    initialValue={[]}
                                    rules={[
                                        {
                                            validator: async (_, names) => {
                                                if (!names || names.length < 1) {
                                                    return Promise.reject(new Error('At least one description is required'));
                                                }
                                            },
                                        },
                                    ]}
                                >
                                    {(fields, { add, remove }) => (
                                        <>
                                            {fields.map(({ key, name, fieldKey, ...restField }) => (
                                                <Space key={key} style={{ display: 'flex', marginBottom: 8 }} align="baseline">
                                                    <Form.Item
                                                        {...restField}
                                                        name={[name, 'description']}
                                                        rules={[
                                                            { required: true, message: 'Please input a description!' },
                                                            { type: 'string', message: 'Each description must be a string!' },
                                                        ]}
                                                    >
                                                        <Input placeholder="Enter description" />
                                                    </Form.Item>
                                                    <Button onClick={() => remove(name)} icon="-">
                                                        Remove
                                                    </Button>
                                                </Space>
                                            ))}
                                            <Form.Item>
                                                <Button type="dashed" onClick={() => add()} icon="+">
                                                    Add Description
                                                </Button>
                                            </Form.Item>
                                        </>
                                    )}
                                </Form.List>
                            </Form.Item>
                        </Col>


                        <Form.Item>
                            <Button type="primary" htmlType="submit" loading={isLoading}>
                                {isLoading ? 'Creating...' : 'Create'}
                            </Button>
                        </Form.Item>
                    </Row>

                </Form>
            </Card>

            <Card>
                <h2 className="text-center mt-4">Course Module List</h2>
                <Card className="mb-4">
                    <Form
                        form={form1}
                        layout="inline"
                        onFinish={filterCourseData}
                        style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}
                    >
                        <Form.Item
                            label="Course"
                            name="Course_id"
                        // rules={[{ required: true, message: 'Please select a Course!' }]}
                        >
                            <Select placeholder="Select a Course" allowClear>
                                {allCourseData.map((Course: { id: number; course_title: string }) => (
                                    <Select.Option key={Course.id} value={Course.id}>
                                        {Course.course_title}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                        <Form.Item>
                            <Button type="primary" htmlType="submit">
                                Filter
                            </Button>
                            <Button
                                style={{ marginLeft: 8 }}
                                onClick={() => {
                                    form.resetFields();
                                    setCourseFilterData([]); // Clear filtered data
                                    feacthallCourse();
                                }}
                            >
                                Reset
                            </Button>
                        </Form.Item>
                    </Form>
                </Card>
                <Table
                    columns={columns}
                    dataSource={CourseFilterData.length ? CourseFilterData : allModuleData}
                    loading={isLoading}
                    pagination={{ pageSize: 5 }}
                    scroll={{ x: "max-content" }}
                    locale={{
                        emptyText: isLoading ? 'Loading...' : 'No Data Found',
                    }}
                />
            </Card>

        </div>
    );
}

export default CourseModule
